import { Injectable } from '@angular/core';
import { DictionaryService } from '@app/core/services/dictionary.service';
import { UserService } from '@app/core/services/user.service';
import { PcsTranslateService } from '@app/core/translate/translate.service';
import { AgencySybTypeId } from '@app/models';
import { TrainType, TrainTypeId } from '@app/pcs/models';
import { findTrainTypeById } from '@app/pcs/util/train-type';
import { containsAgencySubTypeIdWithId, isApplicantAgencyTypeId } from '@util';
import * as R from 'ramda';

@Injectable()
export class TrainTypeService {

  constructor(private dictionaryService: DictionaryService,
    private translateService: PcsTranslateService,
    private userService: UserService) {
  }

  getSortedTrainTypes() {
    const trainTypes = this.dictionaryService.getTrainTypes();
    return R.sortBy(trainType => this.translateService.translate(R.prop('description', trainType)))(trainTypes);
  }

  getDefaultTrainTypeForUser(): TrainType {
    const trainTypes = this.getSortedTrainTypes();
    const defaultTrainType = this.userService.getDefaultTrainType();
    return R.isNil(defaultTrainType)
      ? R.head(trainTypes) as TrainType
      : defaultTrainType;
  }

  getDefaultTrainTypeForPapAndPamtSearch(): TrainType {
    const agency = this.userService.getAgency();
    const agencyTypeId = this.userService.getAgencyTypeId();
    const trainTypes = this.dictionaryService.getTrainTypes();

    return !isApplicantAgencyTypeId(agencyTypeId) || containsAgencySubTypeIdWithId(AgencySybTypeId.Cargo)(agency)
      ? findTrainTypeById(trainTypes, TrainTypeId.Cargo)
      : this.getDefaultTrainTypeForUser();
  }
}
